import Snackbar from '@zenbusiness/zui/Snackbar';
import { styled } from '@zenbusiness/zui/styles';

export const SnackbarStyles = ({ theme, offset, top }) => ({
  top: top ? `${top} !important` : '',
  maxWidth: 'calc(100% - 32px)', // spacing left and right is 16px
  margin: 'auto',
  [theme.breakpoints.down('md')]: {
    bottom: offset
  },
  [theme.breakpoints.up('sm')]: {
    maxWidth: 'none'
  }
});

export const SnackbarStyled = styled(Snackbar)(SnackbarStyles);
